import Loader from "react-loader-spinner";
import { faBug, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { addEditProductBug, deleteProductBug, getNextProductBugCode, searchProductBug } from "../store/api/TaskDetailsApi";
import BihamtaTable from "../../Components/BihamtaTable";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckLg, DashCircle, ExclamationTriangle, List, Pencil, PencilFill, PlusSquare, Search } from "react-bootstrap-icons";
import { keyIsLetterOrNumber, setDialog, translateError } from "../../store/api/CommonFunctions";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAllProductTypesNew } from "../../store/api/GetAllProduct";

const ModalProductBugs = (props) => {
    const dispatch = useDispatch();
    const [submitError, setSubmitError] = useState(null);
    const { popData, setPopData } = props;
    const [popProduct, setPopProduct] = useState({ show: false });
    const filterData = useRef({});
    const [typeList, setTypeList] = useState([]);
    const [showTypes, setShowTypes] = useState(false);
    const [currentBug, setCurrentBug] = useState(null);
    const { show } = popData;
    const settingNames = ['ProductGrouppingType'];
    const { systemSettings } = useSelector(state => { return { systemSettings: state.SystemSettingsReducer.systemSettings } });

    const productGrouppingType = systemSettings && Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    function close() {
        setCurrentBug(null);
        setPopData({ show: false });
        filterData.current = {};
    }
    function search() {
        filterData.current.Skip = 0;
        filterData.current.Take = 5;
        dispatch(searchProductBug(filterData.current));
    }
    function onSubmit() {
        setSubmitError(null);
        if ((currentBug.Code ?? "") === "") {
            setSubmitError("کد ایراد وارد نشده است");
            return;
        }
        if ((currentBug.Bug ?? "") === "") {
            setSubmitError("شرح ایراد وارد نشده است");
            return;
        }
        const onAddUpdate = (res) => {
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else if (res.Data) {
                filterData.current = { Skip: 0, Take: 5 };
                setCurrentBug(null);
                setShowTypes(false);
            }
        }
        if (currentBug.e) {
            delete currentBug.e;
        }
        if (currentBug.ProductTypeID && !currentBug.RelatedProductName) {
            currentBug.RelatedProductName = typeList.find(t => Number(t.ID) === Number(currentBug.ProductTypeID))?.Name;
        }
        dispatch(addEditProductBug(currentBug, onAddUpdate));
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد ایراد", colName: "Code", showInMobile: true },
        { colTitle: "شرح ایراد", colName: "Bug" },
        { colTitle: "نام محصول", colName: "RelatedProductName", showCondition: () => productGrouppingType === 1 },
        { colTitle: "نوع محصول", colName: "ProductTypeName", showCondition: () => productGrouppingType !== 1 }
    ]
    const rowButtons = [
        { type: "common", title: "ویرایش ایراد", className: "group-Btn-smalll", icon: <PencilFill color="orange" size={18} />, onclick: setForEdit },
        {
            title: "حذف ایراد", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف ایراد',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteProductBug(item.ID, onDelete)
                }))
            }
        }
    ];
    const onDelete = (res) => {
        if (res.Error) {
            setSubmitError(translateError(res.Error));
        }
    }
    function setForEdit(row) {
        if (currentBug) {
            return;
        }
        setShowTypes(Number(row.ProductTypeID) > 0);
        setCurrentBug(row);
    }
    function setForAdd() {
        const onGetCode = (res) => {
            if (res.Data) {
                setCurrentBug({ ID: 0, Code: res.Data });
            }
            else if (res.Error) {
                setCurrentBug({ ID: 0 });
            }
        }
        getNextProductBugCode(onGetCode)
    }
    function cancel() {
        setSubmitError(null);
        setCurrentBug(null);
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setCurrentBug({ ...currentBug, ProductName: data.ProductName + "-" + data.ProductModel, RelatedProductHardCode: data.ProductHardCode, RelatedProductName: data.ProductName });
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
    }
    function showHideTypes(show) {
        if (show && !(typeList?.length > 0)) {
            getAllProductTypesNew(setTypeList);
        }
        setShowTypes(show);
    }
    useEffect(() => {
        if (show) {
            dispatch(getSystemSettings(settingNames));
            filterData.current = { Skip: 0, Take: 5 };
            dispatch(searchProductBug(filterData.current));
            setShowTypes(false);
            getAllProductTypesNew(setTypeList);
        }
    }, [show])
    return (
        <Modal size="lg" show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faBug} size="lg" /> &nbsp;
                    مدیریت ایرادات فنی
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} />
                {currentBug &&
                    <Row className="rowBorder">
                        {productGrouppingType !== 1 &&
                            <div className="rowTitle">
                                <input type="checkbox" className="form-check-input" onChange={e => showHideTypes(e.target.checked)} defaultChecked={Number(currentBug.ProductTypeID) > 0} />&nbsp; ثبت برحسب نوع محصول
                            </div>
                        }
                        <Col className="form-group" md={3}>
                            <label>کد ایراد: </label>
                            <Form.Control defaultValue={currentBug.Code ?? ""} onChange={e => currentBug.Code = e.target.value} />
                        </Col>
                        <Col className="form-group" md={4}>
                            <label>شرح ایراد: </label>
                            <Form.Control defaultValue={currentBug.Bug ?? ""} onChange={e => currentBug.Bug = e.target.value} />
                        </Col>
                        {showTypes ?
                            <Col className="form-group" md={5}>
                                <label>نوع محصول: </label>
                                {typeList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {typeList && Array.isArray(typeList) &&
                                    <select className="form-control" defaultValue={currentBug.ProductTypeID ?? ""} onChange={e => currentBug.ProductTypeID = e.target.value}>
                                        <option value="">انتخاب کنید</option>
                                        {typeList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col> :
                            <Col className="form-group" md={5}>
                                <label>محصول مرتبط: </label>
                                <Form.Control value={currentBug.RelatedProductName ?? ""} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalProduct}><List size={21} /></Button>
                            </Col>
                        }
                        <Col md={4} className="form-group" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px" }}>
                            <Button variant="info" className="group-Btn" onClick={onSubmit}>
                                {Number(currentBug.ID) > 0 &&
                                    <Fragment>
                                        <Pencil size={16} />&nbsp; ویرایش ایراد
                                    </Fragment>
                                }
                                {Number(currentBug.ID) === 0 &&
                                    <Fragment>
                                        <CheckLg size={16} />&nbsp; ثبت ایراد
                                    </Fragment>
                                }
                            </Button>
                            <Button variant="danger" className="group-Btn" onClick={cancel}><DashCircle size={17} />&nbsp; انصراف</Button>
                        </Col>

                    </Row>
                }
                {!currentBug &&
                    <Row className="rowBorder">
                        <Col md={3} className="form-group">
                            <label>کد ایراد: </label>
                            <Form.Control onChange={e => filterData.current.Code = e.target.value} />
                        </Col>
                        <Col md={3} className="form-group">
                            <label>شرح ایراد: </label>
                            <Form.Control onChange={e => filterData.current.Bug = e.target.value} />
                        </Col>
                        <Col md={3} className="form-group">
                            <label>محصول مرتبط: </label>
                            <Form.Control onChange={e => filterData.current.RelatedProductName = e.target.value} />
                        </Col>
                        <Col className="form-group" md={3}>
                            <label>نوع محصول: </label>
                            {typeList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {typeList && Array.isArray(typeList) &&
                                <select className="form-control" onChange={e => filterData.current.ProductTypeID = e.target.value}>
                                    <option value="">انتخاب کنید</option>
                                    {typeList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={3} className="from-group mt-1" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px" }}>
                            <Button className="group-Btn" onClick={search}><Search size={17} />&nbsp; جستجوی ایراد</Button>
                        </Col>
                    </Row>
                }
                {submitError && <Alert variant="danger" style={{ width: "90%", margin: "auto", marginTop: "5px" }}>
                    <ExclamationTriangle size={18} />&nbsp;
                    {submitError}
                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setSubmitError(null)} style={{ float: "left" }} />
                </Alert>}
                {!currentBug && <Button variant="info" className="group-Btn mt-1" onClick={setForAdd}><PlusSquare size={20} /></Button>}
                <BihamtaTable columns={tableCols} filterData={filterData.current} rowButtons={rowButtons} searchMethod={(data) => dispatch(searchProductBug(data))} reducerName="ProductReducer" objectName="productBugList" hasPaging={true} />
            </Modal.Body>
        </Modal>
    )

}
export default ModalProductBugs;